import styles from './index.module.scss'
import { Carousel } from 'antd'

export default function LeftBox () {
    const baseUrl = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/'
    const images = [
        `${baseUrl}login-bg1.png`,
        `${baseUrl}login-bg2.png`,
    ]

    return (
        <div className={styles.LeftBox}>
            <Carousel autoplay autoplaySpeed={3000}>
                {images.map((src) => (
                    <div key={src}>
                        <img className={styles.BgImage} src={src} alt="" />
                    </div>
                ))}
            </Carousel>
        </div>
    )
}
